




































































import moment from 'moment-timezone';

import { Component, Vue } from 'vue-property-decorator';
import { firebaseDB, firebaseStorage } from '@/firebase';

import { stringToByte } from '@/models/Utils';
import api from '@/api';
import constants from '@/utils/constants';

interface ImageEntity {
  code: string;
  status: string;
  filename: string;
}

@Component
export default class MenuImageBatchUpload extends Vue {
  public $swal: any;

  public uploading: boolean = false;

  public latestUpdateImageDate: string = '';

  public files: any[] = [];

  public filesInfo: any[] = [];

  public illegalImg: any[] = [];

  public filesSize: any = '200 KB';

  public fieldsSet: any[] = [
    { key: 'code', label: 'Code' },
    { key: 'filename', label: 'File Name' },
    { key: 'status', label: 'Status' },
    { key: 'actions', label: '' }
  ];

  get items(): ImageEntity[] {
    return this.files.map(v => {
      return {
        code:
          String(v.name)
            .split('.')
            .shift() || '',
        status: '',
        filename: v.name
      };
    });
  }

  mounted() {
    this.uploading = false;

    const doc = firebaseDB.collection('Maintenance').doc('Global');
    doc.get().then(snapshot => {
      if (snapshot.exists) {
        this.latestUpdateImageDate = snapshot.get('LatestUpdateImageDate');
      } else {
        this.latestUpdateImageDate = moment().format('YYYYMMDDHHmmss');
        doc.set({
          LatestUpdateImageDate: parseInt(this.latestUpdateImageDate)
        });
      }
    });
  }

  formatNames(files) {
    if (files.length < 3) {
      return files.map(v => v.name).join(', ');
    } else {
      const filename = files
        .slice(0, 3)
        .map(v => v.name)
        .join(', ');
      return `${filename} and ${files.length - 3} files selected`;
    }
  }

  removeFile(item, index, target) {
    this.files = this.files.filter((_, i) => i !== index);
  }

  resetAll() {
    this.files = [];
    this.filesInfo = [];
  }

  async uploadImages() {
    const task = this.files.map(v => {
      return firebaseStorage
        .ref()
        .child(`MenuImages/${v.name}`)
        .put(v);
    });
    return Promise.all(task);
  }

  async uploadAll() {
    this.filesInfo = [];
    let isUploadFailed: boolean = false;
    let illegalImg: any = [];
    let lastImg: any = [];
    this.files.map(v => {
      this.filesInfo.push({
        name: v.name,
        size: v.size
      });
    });
    this.filesInfo.map(v => {
      if (v.size > stringToByte(this.filesSize)) {
        illegalImg.push(v.name);
      }
    });
    if (illegalImg.length !== 0) {
      if (illegalImg.length >= 2) {
        lastImg.push(illegalImg[illegalImg.length - 1]);
        illegalImg.splice(illegalImg.length - 1, 1);
        this.$swal(
          'The maximum size of the image should be 200KB!',
          `${illegalImg.join(' , ')} and ${lastImg.join(
            ' , '
          )} are oversized, please compress and upload again.`,
          constants.STATUS_ERROR
        );
      } else if (illegalImg.length === 1) {
        this.$swal(
          'The maximum size of the image should be 200KB!',
          `${illegalImg.join(
            ' , '
          )} is oversized, please compress and upload again.`,
          constants.STATUS_ERROR
        );
      }
    } else {
      this.uploading = true;

      const uploadAt = moment().format('YYYYMMDDHHmmss');

      try {
        await this.uploadImages();
      } catch {
        this.$swal('Upload image failed!', '', constants.STATUS_WARNING);
        this.uploading = false;
        return;
      }

      const paging = {
        page: 1,
        size: 20,
        total: 0
      };

      const soring = {
        byField: '',
        isDesc: false
      };

      const global = this.items.map(v => {
        const filtering = {
          code: v.code,
          cond: 'IMGURL',
          description: null
        };

        return api.GetAllGlobal(paging, soring, filtering);
      });

      let results;

      try {
        results = await Promise.all(global);
      } catch {
        this.$swal('Pull data from MTH failed!', '', constants.STATUS_WARNING);
        this.uploading = false;
        return;
      }

      const exists = results
        .filter(
          v =>
            parseInt(v.data.code) === constants.STATUS_200 &&
            v.data.data.length > 0
        )
        .map(v => {
          return v.data.data[0];
        });

      const task = this.items.map(({ code, filename }, index, a) => {
        const data = {
          code: code,
          cond: 'IMGURL',
          description: filename
        };

        let ret;

        const p = exists.find(v => v.code === code);
        if (p) {
          ret = api.UpdateGlobal(p.id, data).then(v => {
            a[index].status = 'Updated';
            return a[index];
          });
        } else {
          ret = api.CreateGlobal(data).then(v => {
            a[index].status = 'Created';
            return a[index];
          });
        }

        return ret.catch(() => {
          a[index].status = 'Failed';
          isUploadFailed = true;
          return a[index];
        });
      });

      try {
        results = await Promise.all(task);
      } catch {
        this.$swal('Push data to MTH failed!', '', constants.STATUS_WARNING);
        this.uploading = false;
        return;
      }

      try {
        firebaseDB
          .collection('Maintenance')
          .doc('Global')
          .update({
            LatestUpdateImageDate: parseInt(uploadAt)
          });
      } catch {
        this.$swal('Update firebase failed!', '', constants.STATUS_WARNING);
        this.uploading = false;
        return;
      }

      this.latestUpdateImageDate = uploadAt;

      if (isUploadFailed) {
        this.$swal('Upload menu image failed!', '', constants.STATUS_ERROR);
      } else {
        this.$swal('Upload menu image succeed!', '', constants.STATUS_SUCCESS);
      }
      isUploadFailed = false;
      this.uploading = false;
    }
  }
}
